<template>
    <div ref="preview" class="watermark-preview">
        <!-- 平铺图片 -->
        <template
            v-if="
                Const.Watermark.Position.Repeat == data.position &&
                data.watermarkType == Const.Watermark.Type.Image
            "
        >
            <img
                v-for="(style, i) in repeatStyles"
                :key="i"
                :style="style"
                :src="data.imagePath"
                @load="onImageLoaded"
            />
        </template>
        <!-- 平铺文字 -->
        <template
            v-else-if="
                Const.Watermark.Position.Repeat == data.position &&
                data.watermarkType == Const.Watermark.Type.Text
            "
        >
            <div
                v-for="(style, i) in repeatStyles"
                :key="i"
                :style="style"
                :src="data.imagePath"
                @load="onImageLoaded"
            />
        </template>
        <!-- 图片 -->
        <img
            v-else-if="data.watermarkType == Const.Watermark.Type.Image"
            :src="data.imagePath"
            :style="imageStyle"
            @load="onImageLoaded"
        />
        <!-- 文字 -->
        <div v-else :style="imageStyle" />
    </div>
</template>
<script>
import { Const } from "@/model/ApiModel";
import config from "@/config";

var SCENE = {
    width: 1280,
    height: 720,
    ratio: 1280 / 720,
    marginXRatio: 0.043,
    marginYRatio: 0.0375,
};
var gContext = document.createElement("canvas").getContext("2d");

export default {
    name: "MaterialTemplatePreview",
    props: {
        data: {
            required: true,
        },
    },
    data() {
        return {
            Const,
            previewWidth: 0,
            previewHeight: 1,
            imageWidth: 100,
            imageHeight: 100,
        };
    },
    computed: {
        imageStyle() {
            const Position = Const.Watermark.Position;

            let marginX = this.previewWidth * SCENE.marginXRatio;
            let marginY = this.previewHeight * SCENE.marginYRatio;
            let scale = this.previewWidth / SCENE.width;
            let imgWidth = this.imageWidth;
            let imgHeight = this.imageHeight;

            marginX *= scale;
            marginY *= scale;
            imgWidth *= scale;
            imgHeight *= scale;

            const style = {
                left: marginX,
                top: marginY,
                width: imgWidth,
                height: imgHeight,
            };

            switch (this.data.position) {
                case Position.LeftTop:
                    // nothing
                    break;
                case Position.LeftBottom:
                    style.top = this.previewHeight - (imgHeight + marginY);
                    break;
                case Position.RightTop:
                    style.left = this.previewWidth - (imgWidth + marginX);
                    break;
                case Position.RightBottom:
                    style.left = this.previewWidth - (imgWidth + marginX);
                    style.top = this.previewHeight - (imgHeight + marginY);
                    break;
                case Position.Center:
                    style.left = (this.previewWidth - imgWidth) / 2;
                    style.top = (this.previewHeight - imgHeight) / 2;
                    break;
                case Position.Repeat:
                    break;
            }
            return {
                left: style.left + "px",
                top: style.top + "px",
                width: style.width + "px",
                height: style.height + "px",
                position: "absolute",
                "background-color": this.data.fontColor,
            };
        },
        repeatStyles() {
            var styles = [];
            if (this.data.position == Const.Watermark.Position.Repeat) {

                let scale = this.previewWidth / SCENE.width;
                let watermarkW = this.imageWidth;
                let watermarkH = this.imageHeight;

                if(watermarkW <= 0 || watermarkH <= 0 || this.previewWidth <= 0 || this.previewHeight <=0) {
                    return styles;
                }

                watermarkW *= scale;
                watermarkH *= scale;
                
                var margin = watermarkH / 2;
                var offsetX =
                    -watermarkW + (this.previewWidth % watermarkW) / 2;

                var yEven = false;
                for (var y = 0; y < this.previewHeight; y += watermarkH + margin) {
                    var xEven = false;
                    for (
                        var x = offsetX;
                        x < this.previewWidth;
                        x += watermarkW
                    ) {
                        if (yEven == xEven) {
                            styles.push({
                                left: x+"px",
                                top: y+"px",
                                width: watermarkW+"px",
                                height: watermarkH+"px",
                                position: "absolute",
                                "background-color": this.data.fontColor,
                            });
                        }
                        xEven = !xEven;
                    }
                    yEven = !yEven;
                }
            }
            return styles;
        },
    },
    methods: {
        onImageLoaded(event) {
            this.imageWidth = event.target.naturalWidth;
            this.imageHeight = event.target.naturalHeight;
        },
        prepareTextSize() {
            let family = this.data.fontFamily;
            var textList = this.data.words.split(/\r?\n/g); //存放切割后的内容
            var fontSize = this.data.fontSize;
            var height = fontSize + fontSize * 1.5 * (textList.length - 1); // line-height=1.5
            var width = 0;

            family = config.FontMap[family] || family || "黑体"; // family 必须有，否则无法设置ctx.font
            gContext.font = fontSize + "px " + family;
            for (var b = 0; b < textList.length; b++) {
                width = Math.max(
                    width,
                    gContext.measureText(textList[b]).width
                );
            }

            this.imageWidth = width;
            this.imageHeight = height;
        },
    },
    mounted() {
        this.previewWidth = this.$refs.preview.offsetWidth - 4;
        this.previewHeight = this.$refs.preview.offsetHeight - 4;
        if (this.data.watermarkType != Const.Watermark.Type.Image) {
            this.prepareTextSize();
        }
    },
};
</script>
<style lang="less" scoped>
.watermark-preview {
    border: 2px solid #aaa;
    background: #aaa;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
}
</style>